import {TimeSlot} from "../types";
import {resetBooking} from "../lib/booking";

interface BookingFlows {
    [booking_flow:string] : BookingFlow
    default : BookingFlow,
    window : BookingFlow,
    hjulskifte : BookingFlow,
    tacdis : BookingFlow
}

interface BookingFlow {
    menu: any,
    step:string
}

interface BookingCalendar {
    slots: TimeSlot[]
}

interface WindowRepairImage {
    image: string
}

interface Offer {
    id: number,
    header: string,
    expire: string,
    description: string,
    sidebar_service: string,
    active: boolean,
    requirement: []
}

interface Discount {
    id: number,
    code: string,
    active:boolean
}

interface Campaigns {
    offers: Offer[]
    discounts: Discount[]
}

const campaigns:Campaigns = {
    offers: null,
    discounts: null
}

const bookingCalendar:BookingCalendar = {
    slots: null,
}

const windowRepairImage:WindowRepairImage = {
    image:''
}

const bookingFlows:BookingFlows = {
    default: {
        menu: ['car', 'service', 'date', 'options', 'contact', 'complete'],
        step: 'car'
    },
    window: {
        menu: ['car', 'service', 'window', 'date', 'options', 'contact', 'complete'],
        step: 'car'
    },
    hjulskifte: {
        menu: ['car', 'service', 'date', 'options', 'contact', 'complete'],
        step: 'car'
    },
    "hjulskifte-arval": {
        menu: ['car', 'service', 'date', 'options', 'contact', 'complete'],
        step: 'car'
    },
    tacdis: {
        menu: ['car', 'service', 'date', 'options', 'contact', 'complete'],
        step: 'car'
    }
}

const hjulskifteFlows:[string, string] = ['hjulskifte', 'hjulskifte-arval']

const bookingDefault:Booking = resetBooking()

const settings:any = {
    auth:[],
    vbo:[],
    rental:[],
    debug:false,
    tire_shop:false,
    react_thank_you:false,
}

const site:string = window.react_data.home_url ? window.react_data.home_url : 'https://mechanum-theme-2019.test'
const tire_shop =  window.react_data.tire_shop ? window.react_data.tire_shop : 'https://mechanum-theme-2019.test/shop'

export { hjulskifteFlows, bookingFlows, bookingDefault, site, tire_shop, bookingCalendar, windowRepairImage, settings, campaigns }
